import type { EventEvent } from '@grafana/faro-web-sdk'

const CLOUDFLARE_CSP_REPORT_TO = 'report-to cf-csp-endpoint'

export function isCloudflareReportCspViolation(event: EventEvent) {
  return (
    event.name === 'securitypolicyviolation' &&
    event.attributes?.disposition === 'report' &&
    event.attributes?.originalPolicy?.includes(CLOUDFLARE_CSP_REPORT_TO) ===
      true
  )
}
